import styled from 'styled-components'
import { ClbRadioGroup } from '@celebration/react'
import { NxText } from '../../text'
import { NxHeading } from '../../heading'

export const Container = styled.div`
  width: 100%;
`

export const Label = styled(NxHeading).attrs({
  size: 'xs',
  type: 'h4',
})`
  display: inline-block;
  margin-right: var(--spacing-size-4xs);
`

export const Description = styled(NxText)`
  display: block;
`

export const Group = styled(ClbRadioGroup).attrs<{ orientation?: 'list' }>({ orientation: 'list' })`
  flex-direction: column;
  gap: var(--spacing-size-4xs);
  display: flex;
  margin: var(--spacing-size-3xs) 0;

  & input[type='radio'] {
    transform: none;
  }
`
